import { useContext } from "react";

import { ToastContext, type ToastContextValue } from "../components/ui/ToastProvider";

export function useToast(): ToastContextValue {
  const value = useContext(ToastContext);
  if (value === null) {
    throw new Error("useToast must be used within ToastProvider");
  }
  return value;
}
